<template>
    <div class="h-100">
        <div class="loader-cont" v-dxloader="isLoader"></div>   
        <div class="row h-100" v-show="!isLoader">
            <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
            <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
                <!-- Search for small screen-->
                <div class="container">
                    <div class="row">
                        <div class="col s10 m6 l6 alignLeft">
                            <h5 class="card-title alignLeft white-text">Pay Out</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col s12 p-0" style="height:calc(100% - 45px)">
                <div class="container p-0 h-100">
                    <div class="section p-0 h-100">
                        <div class="row m-0 h-100">
                            <div class="col s12 m12 l12 p-0 h-100">
                                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                                    <div class="card-content h-100" style="overflow:auto">
                                        <div class="col s6 filter-cls">
                                            <div class="input-field">
                                                <i class="material-icons mr-2 close-icon" @click="resetFilter($event)">close</i>
                                                <input type="text" id="autocomplete-input" class="autocomplete">
                                                <label for="autocomplete-input" style="color: #212121">Filter by vendor</label>
                                            </div>
                                        </div>

                                        <div class="row payoutblock"  style="height: calc(100% - 84px)">
                                            <div class="col s12">
                                                <table class="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th data-field="index">#</th>
                                                            <th data-field="index">Vendor</th>
                                                            <th data-field="name">Cost</th>
                                                            <th data-field="id">Audits</th>
                                                            <th data-field="price">Bookings</th>
                                                            <th data-field="total">Billing Cycle</th>
                                                            <th data-field="status">Status</th>
                                                            <th data-field="date">Created At</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item,index) in payOutsList.results" :key="item.id">
                                                            <td>{{index + 1}}.</td>
                                                            <td>
                                                                <div class="vendor-cls">
                                                                    <span class="img"><img v-if="item.vendor.profile_pic" :src="item.vendor.profile_pic"></span>   
                                                                    <span> {{item.vendor.first_name}}({{item.vendor.rep_id}})</span>
                                                                </div>
                                                            </td>
                                                            <td>Rs.{{item.payable_cost}}</td>
                                                            <td>{{item.services_count || 0}}</td>
                                                            <td>{{item.audits_count || 0}}</td>
                                                            <td>{{item.start_date | date('DD MMM')}} - {{item.end_date | date('DD MMM')}} '{{item.end_date | date('YY')}}</td>
                                                            <td class="caps">{{item.is_paid ? "Paid" : "Not Paid"}}</td>
                                                            <td>{{item.created_at | date('DD MMM YY, hh:mm a')}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isLoader : true,
                vendorList : [],
                payOutsList : {
                    results : [],
                    count : 0,
                    previous : null,
                    next : null
                },
            }
        },
        created(){
            this.listpayOuts();
            this.listAllVendors();
             var thisObj = this;
            setTimeout(() => {
                Vue.scrollBottom("", () => {
                    if (thisObj.payOutsList.next) {
                        thisObj.listpayOuts(thisObj.payOutsList.next, true);
                    }
                })
            }, 500);
        },
        methods : {
            listpayOuts(url = Constants.default.APIURL.PayOuts,status=false) {
                return new Promise(resolve => {
                    ajax.get(
                    url,
                    res => {
                        this.isLoader = false;
                        if (status) {
                            let temp = this.payOutsList.results;
                            this.payOutsList = {
                                count: res.data.count,
                                previous: res.data.previous,
                                next: res.data.next
                            };
                            this.payOutsList.results = temp.concat(res.data.results);
                        } else {
                            this.payOutsList = res.data;
                        }
                        if(this.payOutsList.results.length==0){
                            Vue.showNoDataBlock('.payoutblock');
                        }else{
                            Vue.hideNoDataBlock('.payoutblock');
                        }
                    },err =>{
                        this.isLoader = false;
                    });
                });
            },
            listAllVendors() {
                return new Promise(resolve => {
                    ajax.get(
                        Constants.default.APIURL.ListAllVendors,
                        res => {
                            let data = {};
                            this.vendorList = res.data;
                            this.vendorList.forEach(val =>{
                                data[val.first_name + ' (' + val.business_details.rep_id + ')'] = val.profile_pic;
                            });
                             let opts = {
                                data: data,
                                minLength : 0,
                                onAutocomplete : (text)=>{
                                    let rep_id = text.split(' ')[text.split(' ').length-1];
                                    let vendor = this.vendorList.filter(val =>{
                                        return val.rep_id == rep_id;
                                    })[0];
                                    let url = Constants.default.APIURL.PayOuts + vendor.id;
                                    this.listpayOuts(url);
                                    $('i.close-icon').eq(0).show();
                                    M.updateTextFields();
                                }
                                };
                                $('.autocomplete').on('keyup',(e) =>{
                                    if(!e.target.value){
                                        $('i.close-icon').eq(0).hide();
                                        this.listpayOuts();
                                    }
                                })
                                setTimeout(() =>{
                                    window.autocompleteInstance = M.Autocomplete.init(document.querySelectorAll('.autocomplete'), opts);
                                    setTimeout(() =>{
                                        $('.autocomplete').on('focusin',(e) =>{
                                        if(autocompleteInstance[0] && !autocompleteInstance[0].isOpen){
                                            setTimeout(() =>{
                                            autocompleteInstance[0].open();
                                            },100);
                                        }
                                        });
                                    },100);
                                },300);
                            resolve(true);
                        },
                        err => {
                            resolve(false);
                        }
                    );
                });
            },
            resetFilter(ev){
                $(ev.target).closest('div').children().each((key,dom)=>{
                    if(dom.tagName == "INPUT"){
                        dom.value = "";
                    }
                });
                this.listpayOuts();
                setTimeout(() =>{
                    $(ev.target).hide();
                    M.updateTextFields();
                },200);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .caps{
        text-transform: capitalize;
    }
    .input-field{
        margin-bottom: 20px !important;
        margin-top: 10px !important;
    }
    .filter-cls{
        width: 35% !important;
        .input-field{
            i.close-icon{
                position: absolute;
                display: none;
                cursor: pointer;
                right: 0;
                font-size: 18px;
                top: 15px;
            }
        }
    }

    .card .card-content .card-title{
        margin-top: 15px;
    }
    .vendor-cls {
        display: flex;
        align-items: center;
        span{
            margin: 0 5px;
        }
        span.img {
            width: 30px;
            height: 30px;
            overflow: hidden;
            display: inline-block;
            background: gainsboro;
            border-radius: 50%;
            img{
                width: 100%;
            }
        }
    }
</style>

